<template>
  <div v-if="user && user.type" id="nav" class="md:flex flex-col w-64 h-screen absolute md:relative overflow-auto" :class="{ 'hide-menu': ShowSidebar(), 'vertical-navigation-mode-over': resize() }">

    <!-- Logo Header -->
    <div class="sidebar-header">
      <router-link class="flex items-center no-active dashbord" to="/">
          <img
            alt="Logo"
            class="sidebar-logo"
            :src="brandingLogo || image"
          />
          <b class="sidebar-brand-text">
            {{ brandingTitle }}
          </b>
        </router-link>
        <img class="flag-img" :src="flag" />
      <button v-if="resize()" @click="actionSidebar" class="sidebar-close-btn">
        <i class="material-icons">close</i>
      </button>
    </div>

    <!-- Menu -->
    <div class="sidebar-menu">

      <!-- Section Label -->
      <div v-if="hasMainMenu" class="sidebar-section-label">Main Menu</div>

      <menu-link v-if="getPermission('dashboard')" to="/" text="Dashboard" class="link" icon="dashboard"/>

      <menu-link v-if="getPermission('warehouses') && getAccess('warehouses', 'create')" to="/warehouses" text="Warehouses" class="link" icon="business" :hasSubmenu="true" :submenuRoutes="['warehouses', 'newWarehouse', 'regroupements']" />

      <div v-if="['warehouses', 'newWarehouse','regroupements'].indexOf($route.name) > -1 && getAccess('warehouses', 'create')">
          <menu-link to="/warehouses/new" text="New warehouse" icon="add" submenu="true" />
      </div>

      <div v-if="['warehouses', 'newWarehouse','regroupements'].indexOf($route.name) > -1 && getAccess('regroupements', 'create')">
          <menu-link to="/regroupements" text="Regroupements" icon="view_module" submenu="true" />
      </div>

      <menu-link v-if="getPermission('products') && (getAccess('products', 'create') || ['StockManager','AccountManager'].includes(user.type))" to="/products" text="Products" class="link" icon="local_mall" :hasSubmenu="true" :submenuRoutes="['products', 'newProduct']" />

      <div v-if="['products', 'newProduct'].indexOf($route.name) > -1 && getAccess('products', 'create')">
        <menu-link to="/products/new" text="New product" icon="add" submenu="true" />
      </div>

      <menu-link v-if="$f.getAccessPermission(user, 'analytics', 'create')" to="/callcenter" text="Analytics" class="link" icon="trending_up" />

      <!-- Section Label -->
      <div v-if="hasCommerce" class="sidebar-section-label">Commerce</div>

      <menu-link v-if="getPermission('orders')  && (getAccess('orders', 'create') || ['CallenterManager','TeleConsultant','NRP','AccountManager'].includes(user.type))" to="/orders" text="Orders" class="link" icon="local_grocery_store" :hasSubmenu="true" :submenuRoutes="['orders', 'newOrder', 'importOrders', 'selleranalytics']" />

      <div v-if="['orders', 'newOrder'].indexOf($route.name) > -1">
        <menu-link to="/orders/new" v-if="getAccess('orders', 'create')" text="New order" icon="add" submenu="true" />
      </div>

      <menu-link v-if="user.type == 'TeleConsultant' || user.type == 'NRP'" to="/orders/confirmation" text="confirmation" icon="add" />

      <div v-if="['orders', 'importOrders'].indexOf($route.name) > -1">
        <menu-link to="/orders/import" v-if="getAccess('orders', 'create')" text="Import orders" icon="add" submenu="true" />
      </div>

      <div v-if="['orders', 'selleranalytics'].indexOf($route.name) > -1 && user.type !== 'Seller' && $f.getAccessPermission(user, 'SellerAnalytics', 'create')">
        <menu-link to="/orders/selleranalytics" v-if="$f.getAccessPermission(user, 'SellerAnalytics', 'create')" text="Seller Analytics" icon="tune" submenu="true" />
      </div>

      <menu-link v-if="getPermission('expeditions')" to="/expeditions" text="Expeditions" class="link" icon="local_airport" :hasSubmenu="true" :submenuRoutes="['expeditions', 'newExpedition']" />

      <div v-if="['expeditions', 'newExpedition'].indexOf($route.name) > -1">
        <menu-link to="/expeditions/new" text="New Expedition" icon="add" submenu="true" />
      </div>

      <menu-link v-if="getPermission('status') && getAccess('status', 'create')" to="/status" text="Status" class="link" icon="sync" />

      <!-- Section Label -->
      <div v-if="hasManagement" class="sidebar-section-label">Management</div>

      <menu-link v-if="getPermission('users') && (getAccess('users', 'create') || user.type == 'CallenterManager')" :to="'/users?typeuser='+user.type" text="Users" class="link" icon="account_circle" :hasSubmenu="true" :submenuRoutes="['users', 'newUser']" />

      <div v-if="['users', 'newUser'].indexOf($route.name) > -1 && getAccess('users', 'create')">
        <menu-link to="/users/new" text="New user" icon="add" submenu="true" />
      </div>

      <menu-link v-if="getPermission('roles') && getAccess('roles', 'update')" to="/roles" text="Roles" class="link" icon="lock" :hasSubmenu="true" :submenuRoutes="['roles', 'newRole']" />

      <div v-if="['roles', 'newRole'].indexOf($route.name) > -1">
        <menu-link to="/roles/new" text="New role " icon="add" submenu="true" />
      </div>

      <menu-link v-if="getPermission('teams')" to="/teams" text="Teams" class="link" icon="group" :hasSubmenu="true" :submenuRoutes="['teams', 'newTeam']" />

      <div v-if="['teams', 'newTeam'].indexOf($route.name) > -1">
        <menu-link to="/teams/new" text="New team " icon="add" submenu="true" />
      </div>

      <menu-link v-if="getPermission('subscribers')" to="/subscribers" text="Subscribers" class="link" icon="supervisor_account" :hasSubmenu="true" :submenuRoutes="['subscribers', 'newSubscribers']" />

      <div v-if="['subscribers', 'newSubscribers'].indexOf($route.name) > -1 && getAccess('subscribers', 'create')">
        <menu-link to="/subscribers/new" text="New subscriber" icon="add" submenu="true" />
      </div>

      <!-- Section Label -->
      <div v-if="hasShipping" class="sidebar-section-label">Shipping & Finance</div>

      <menu-link v-if="((getPermission('zones') || getPermission('shippings')) && getAccess('zones', 'create')) || ['Accountant','AccountManager'].includes(user.type) || (user.type == 'Seller' && getAccess('shippings', 'read'))" to="#" text="Shipping order" class="link" icon="local_shipping" :isActive="isActive" @myFilter="myFilter" />

      <menu-link v-if="getPermission('zones') && getAccess('zones', 'create')" to="/zones" text="Zones" class="link" icon="map" children="true" />

      <div v-if="['zones', 'newZones'].indexOf($route.name) > -1">
        <menu-link to="/zones/new" text="New Zone" icon="add" class="child" submenu="true" />
      </div>

      <menu-link v-if="(getPermission('shippings') && (getAccess('shippings', 'create') || (['StockManager','Courier','AccountManager'].includes(user.type)))) || (user.type == 'Seller' && getAccess('shippings', 'read'))" to="/shippings" text="Shippings" class="link" icon="map" children="true" />

       <menu-link v-if="getAccess('sourcings', 'update')" to="/sourcings" text="Sourcings" class="link" icon="find_in_page" />

      <menu-link v-if="getPermission('payments') || getPermission('refunds')" :to="'/payments?typeuser='+user.type" text="Payments" class="link" icon="payment" :hasSubmenu="true" :submenuRoutes="['payments', 'newPayments', 'multiWarehouses', 'refunds', 'avoirs']" />

      <div v-if="['payments', 'newPayments','multiWarehouses','refunds','avoirs'].indexOf($route.name) > -1 && (getAccess('payments', 'create') || getAccess('payments', 'update'))">
        <menu-link to="/payments/new" text="New payment" icon="add" submenu="true" />
      </div>

      <div v-if="['payments', 'newPayments','multiWarehouses','refunds','avoirs'].indexOf($route.name) > -1 && (getAccess('payments', 'create') || getAccess('payments', 'update'))">
        <menu-link to="/payments/multiwarehouses" text="Multi warehouses" icon="tune" submenu="true" />
      </div>

      <div v-if="['payments', 'refunds','multiWarehouses','avoirs','newPayments'].indexOf($route.name) > -1 && (getAccess('refunds', 'create') || getAccess('refunds', 'read'))">
        <menu-link to="/refunds" text="Refunds" icon="strikethrough_s" submenu="true" />
      </div>

      <div v-if="['payments', 'sourcings','multiWarehouses','refunds','avoirs','newPayments'].indexOf($route.name) > -1 && getAccess('avoirs', 'create')">
          <menu-link to="/avoirs" text="Avoirs" icon="card_giftcard" submenu="true" />
      </div>

      <!-- Tickets -->
      <menu-link v-if="getPermission('tickets')" to="/tickets" text="Tickets" class="link" icon="confirmation_number" :hasSubmenu="true" :submenuRoutes="['tickets', 'newTicket']" />

      <div v-if="['tickets', 'newTicket'].indexOf($route.name) > -1">
        <menu-link to="/tickets/new" text="New ticket" icon="add" submenu="true" />
      </div>

      <!-- Section Label -->
      <div v-if="hasSystem" class="sidebar-section-label">System</div>

      <menu-link v-if="getPermission('settings') && (getAccess('settings', 'update') || (user.type == 'Seller' && getAccess('settings', 'read')))" to="/settings" text="Settings" class="link" icon="settings" />

      <menu-link v-if="getPermission('senders')  && getAccess('senders', 'create')" to="/senders" text="Whatsapp sender" class="link" icon="chat"/>

      <menu-link v-if="user.type == 'Seller'" to="https://storeino.com" :isLinkHref="true" text="Create Store" class="link" icon="store" target="_blank" />

      <menu-link to="/orders/api" v-if="user.type == 'Admin' || user.type == 'Seller'" text="API" icon="import_export" class="link"/>

    </div>
  </div>
</template>

<script>
import image from "@/assets/shipsen-man.jpg";
export default {
  data() {
    return {
      login: false,
      token: null,
      isActive: false,
      status: false,
      hideMenu: false,
      image: image,
      flag: "https://img.icons8.com/material-outlined/2x/image.png",
      brandingLogo: null,
      brandingTitle: 'ShipSen',
    };
  },
  props: {
    idWharhouse: { type: Object },
    user: { type: Object },
  },
  async mounted() {
    this.token = this.$jwtService.getToken();
    this.getAccess("users", "read");
    this.getFlag();
    this.loadBranding();
  },
  watch: {
    'idWharhouse': async function(oldVal, newVal) {
          this.idWharhouse=oldVal;
          this.getFlag();
      },
      idWharhouse: {
        handler() {
          this.getFlag();
          this.loadBranding();
        },
        deep: true
      },
      'user.role': {
        handler() {
          this.loadBranding();
        },
        deep: true
      }
  },
  computed: {
    hasMainMenu() {
      return this.getPermission('dashboard') ||
        (this.getPermission('warehouses') && this.getAccess('warehouses', 'create')) ||
        (this.getPermission('products') && (this.getAccess('products', 'create') || ['StockManager','AccountManager'].includes(this.user.type))) ||
        this.$f.getAccessPermission(this.user, 'analytics', 'create');
    },
    hasCommerce() {
      return (this.getPermission('orders') && (this.getAccess('orders', 'create') || ['CallenterManager','TeleConsultant','NRP','AccountManager'].includes(this.user.type))) ||
        this.user.type == 'TeleConsultant' || this.user.type == 'NRP' ||
        this.getPermission('expeditions') ||
        (this.getPermission('status') && this.getAccess('status', 'create'));
    },
    hasManagement() {
      return (this.getPermission('users') && (this.getAccess('users', 'create') || this.user.type == 'CallenterManager')) ||
        (this.getPermission('roles') && this.getAccess('roles', 'update')) ||
        this.getPermission('teams') ||
        this.getPermission('subscribers');
    },
    hasShipping() {
      return ((this.getPermission('zones') || this.getPermission('shippings')) && this.getAccess('zones', 'create')) ||
        ['Accountant','AccountManager'].includes(this.user.type) ||
        (this.user.type == 'Seller' && this.getAccess('shippings', 'read')) ||
        this.getAccess('sourcings', 'update') ||
        this.getPermission('payments') || this.getPermission('refunds') ||
        this.getPermission('tickets');
    },
    hasSystem() {
      return (this.getPermission('settings') && (this.getAccess('settings', 'update') || (this.user.type == 'Seller' && this.getAccess('settings', 'read')))) ||
        (this.getPermission('senders') && this.getAccess('senders', 'create')) ||
        this.user.type == 'Seller' || this.user.type == 'Admin';
    },
  },
  methods: {
    loadBranding() {
      if (this.idWharhouse && this.user.role && this.user.role.branding && this.idWharhouse._id) {
        const branding = this.user.role.branding.find(
          b => b.warehouse === this.idWharhouse._id || b.warehouse._id === this.idWharhouse._id || b.country === this.idWharhouse.country
        );

        if (branding) {
          this.brandingLogo = branding.logo || null;
          this.brandingTitle = branding.title || 'ShipSen';
        } else {
          this.brandingLogo = null;
          this.brandingTitle = 'ShipSen';
        }
      }
    },
    getFlag() {
      this.flag = this.idWharhouse.flag || this.$f.getCountryCode(this.idWharhouse.country);
    },
    ShowSidebar() {
      return this.$store.getters.ShowSidebar;
    },
    actionSidebar() {
      this.$store.dispatch("actionSidebar");
    },
    resize() {
      return this.$store.getters.resize;
    },
    myFilter: function() {
      this.isActive = !this.isActive;
    },
    async getStatusUser() {
      if (this.user.status == "active") {
        this.status = true;
      } else {
        this.status = false;
      }
    },
    async getUser() {
      const res = await this.$server.me("users");
      if (res.content) this.user = res.content;
      else this.user = [];
    },
    logout() {
      this.$jwtService.destroyToken();
      location.href = "/";
    },
    getAccess(modelToCheck, accessToCheck) {
      const permissions = this.user.role.permissions;
      for (let i in permissions) {
        let model = permissions[i]["model"];
        let access = permissions[i]["access"];

        if (model == modelToCheck) {
          return access[accessToCheck];
        }
      }
    },
    getPermission(name) {
      if (this.user) {
        const permissions = this.user.role.permissions;
        for (let i in permissions) {
          let model = permissions[i]["model"];
          let access = permissions[i]["access"];

          if (model == name) {
            if (access.create || access.read || access.update || access.delete) {
              return true;
            } else {
              return false;
            }
          }
        }
      }
    },
  },
};
</script>

<style>
.vertical-navigation-mode-over {
  position: fixed !important;
  transform: translateZ(0);
  left: 0 !important;
  top: 0 !important;
  bottom: 0;
}

/* Sidebar overlay on mobile */
@media (max-width: 960px) {
  #nav {
    position: fixed;
    z-index: 50;
    box-shadow: 8px 0 30px rgba(0, 0, 0, 0.3);
  }
  #nav.hide-menu {
    transform: translateX(-100%);
    visibility: hidden;
  }
}

/* Sidebar Container */
#nav {
  transition-duration: 0.3s;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-property: visibility, margin-left, margin-right, transform, width, max-width, min-width;
  background: linear-gradient(180deg, #4285f4 0%, #3367d6 100%);
  position: sticky;
  display: flex;
  flex-direction: column;
  flex: 1 0 auto;
  top: 0;
  width: 260px;
  min-width: 260px;
  max-width: 260px;
  height: 100vh;
  min-height: 100vh;
  max-height: 100vh;
  z-index: 10;
  box-shadow: 4px 0 24px rgba(0, 0, 0, 0.12);
}

/* Sidebar Header */
.sidebar-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 16px 16px;
  background: rgba(255, 255, 255, 0.05);
  border-bottom: 1px solid rgba(255, 255, 255, 0.08);
}

.sidebar-logo {
  width: 38px;
  height: 38px;
  border-radius: 10px;
  object-fit: cover;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
}

.sidebar-brand-text {
  margin-left: 10px;
  font-weight: 700;
  font-size: 17px;
  color: #ffffff;
  letter-spacing: 0.3px;
}

.sidebar-close-btn {
  background: none;
  border: none;
  outline: none;
  cursor: pointer;
  color: rgba(255, 255, 255, 0.6);
  transition: color 0.2s;
}
.sidebar-close-btn:hover {
  color: #ffffff;
}
.sidebar-close-btn .material-icons {
  font-size: 24px;
}

/* Sidebar Menu */
.sidebar-menu {
  flex: 1;
  overflow-y: auto;
  overflow-x: hidden;
  padding: 8px 12px 20px;
}

.sidebar-menu::-webkit-scrollbar {
  width: 5px;
}
.sidebar-menu::-webkit-scrollbar-track {
  background: rgba(255, 255, 255, 0.1);
  border-radius: 5px;
}
.sidebar-menu::-webkit-scrollbar-thumb {
  background: rgba(255, 255, 255, 0.35);
  border-radius: 5px;
}
.sidebar-menu::-webkit-scrollbar-thumb:hover {
  background: rgba(255, 255, 255, 0.5);
}

/* Section Labels */
.sidebar-section-label {
  font-size: 11px;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 1.2px;
  color: rgba(255, 255, 255, 0.6);
  padding: 18px 12px 6px;
  margin-top: 4px;
}

/* Menu Links */
.link-menu {
  color: #ffffff;
  border-radius: 8px;
  transition: all 0.2s ease;
  font-size: 14px;
  font-weight: 500;
  padding: 9px 12px;
  margin: 1px 0;
}

.link-menu .material-icons {
  font-size: 20px;
  color: #ffffff;
  margin-right: 10px;
  margin-left: 0;
}

.link-menu .text-menu {
  font-size: 13.5px;
  color: #ffffff;
}

.link:hover .link-menu,
.link:hover {
  background: rgba(255, 255, 255, 0.15);
  color: #ffffff;
  border-radius: 8px;
}

.link:hover .link-menu .material-icons {
  opacity: 1;
}

/* Active state */
.router-link-exact-active:not(.no-active) {
  background: rgba(255, 255, 255, 0.2) !important;
  border-radius: 8px;
  color: #ffffff !important;
  margin: 0;
}

.router-link-exact-active:not(.no-active) .material-icons {
  color: #ffffff;
}

/* Submenu */
.sub-link,
.sub-sub-link {
  margin: 0;
  padding-left: 30px;
}

.child .sub-link {
  padding-left: 40px;
}

.sub-link .link-menu,
.sub-sub-link .link-menu {
  font-size: 13px;
  padding: 7px 12px;
  color: rgba(255, 255, 255, 0.85);
}

.sub-link:hover .link-menu,
.sub-sub-link:hover .link-menu {
  color: #ffffff;
}

/* Image links */
.img-link img:last-child {
  display: none;
}
.link:hover img:last-child {
  display: block;
}
.link:hover img:first-child {
  display: none;
}
.link .router-link-active img:first-child {
  display: none;
}
.link .router-link-active img:last-child {
  display: block;
}

.dashbord img {
  width: 40px;
}

.flag-img {
  width: 22px;
  height: 16px;
  border-radius: 2px;
  margin-left: 6px;
  object-fit: cover;
}
</style>
